import { render } from "./UpdateAddress.vue?vue&type=template&id=30edf144"
import script from "./UpdateAddress.vue?vue&type=script&lang=js"
export * from "./UpdateAddress.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/alaediin-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__